"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var trash_png_1 = __importDefault(require("assets/img/trash.png"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var AnalyticEvents_1 = __importDefault(require("../../../../utils/AnalyticEvents"));
var styles_1 = require("./styles");
var Ticket = function (_a) {
    var isPaidOption = _a.isPaidOption, hasAddOn = _a.hasAddOn, title = _a.title, ticket = _a.ticket, ticketIndex = _a.ticketIndex, updateTicket = _a.updateTicket, deleteTicket = _a.deleteTicket, theme = _a.theme, isMobile = _a.isMobile, isTablet = _a.isTablet, isLottoAmerica = _a.isLottoAmerica, _b = _a.isNewVersion, isNewVersion = _b === void 0 ? false : _b, gameName = _a.gameName, errors = _a.errors;
    var classes = (0, styles_1.styles)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var inputRefs = (0, react_1.useRef)([]);
    var updateNumber = function (value, numberIndex) {
        updateTicket(__assign(__assign({}, ticket), { numbers: ticket.numbers.map(function (number, index) {
                return index === numberIndex ? value : number;
            }) }));
    };
    var setMultiplier = function () {
        var _a;
        updateTicket(__assign(__assign({}, ticket), { multiplier: !ticket.multiplier }));
        var eventId = isLottoAmerica ? 'AE0283' : 'AE0119';
        var event = (_a = window === null || window === void 0 ? void 0 : window.analyticsEventMapping) === null || _a === void 0 ? void 0 : _a[eventId];
        if (event) {
            AnalyticEvents_1.default.logEvent(eventId, __assign(__assign({}, event), { eventCategory: event.eventCategory + '_' + (gameName === null || gameName === void 0 ? void 0 : gameName.toLowerCase().replace(' ', '_')), eventLabel: ticket.multiplier ? 'off' : 'on' }));
        }
    };
    var onNumberChange = function (event, index) {
        var _a;
        var newValue = event.target.value;
        if (newValue.length > 2) {
            return;
        }
        updateNumber(newValue, index);
        if (newValue.length === 2 && ticket.numbers.length > index + 1) {
            (_a = inputRefs.current[index + 1]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    var onKeyDown = function (event, index) {
        var _a;
        if (event.key === 'Backspace' && !ticket.numbers[index] && index > 0) {
            (_a = inputRefs.current[index - 1]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    var mobileViewport = isMobile && !isTablet;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Box, { style: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' } },
            react_1.default.createElement(core_1.Box, { style: { display: isNewVersion ? 'flex' : '', flexDirection: 'column' } },
                react_1.default.createElement(core_1.Typography, { variant: "body2", component: "span", className: classes.inputLabel }, "Ticket ".concat(ticketIndex + 1, " Numbers")),
                isPaidOption && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { id: "custom-label-".concat(ticketIndex + 1), className: classes.srOnly }, "".concat(title, ", Ticket ").concat(ticketIndex + 1)),
                    react_1.default.createElement(core_1.FormControlLabel, { control: react_1.default.createElement(core_1.Checkbox, { color: "primary", checked: ticket.multiplier, onChange: setMultiplier, inputProps: {
                                'aria-labelledby': "custom-label-".concat(ticketIndex + 1)
                            } }), label: title, className: isNewVersion ? classes.addOnUpdated : classes.addOn })))),
            ticketIndex > 0 && isNewVersion && (react_1.default.createElement("span", { style: { display: 'flex', alignItems: 'flex-start', marginTop: '20px' } },
                react_1.default.createElement(core_1.ButtonBase, { style: { width: '100%' }, onClick: function () { return deleteTicket(ticketIndex); } },
                    react_1.default.createElement("img", { alt: 'deleteTicket', src: trash_png_1.default, style: { height: '24x', width: '24px' } }))))),
        react_1.default.createElement("div", { className: isNewVersion ? classes.ticketContainerSpace : classes.ticketContainer },
            ticket.numbers.map(function (number, index) {
                var _a;
                var onChange = function (event) { return onNumberChange(event, index); };
                var onBlur = function () {
                    var _a;
                    var analyticsevent = (_a = window === null || window === void 0 ? void 0 : window.analyticsEventMapping) === null || _a === void 0 ? void 0 : _a['AE0118'];
                    if (analyticsevent) {
                        AnalyticEvents_1.default.logEvent('AE0118', __assign(__assign({}, analyticsevent), { eventCategory: analyticsevent.eventCategory + '_' + (gameName === null || gameName === void 0 ? void 0 : gameName.toLowerCase().replace(' ', '_')) }));
                    }
                };
                var onKey = function (event) { return onKeyDown(event, index); };
                var getIndex = function (num, gName) {
                    switch (num) {
                        case 1:
                            return '1st*';
                        case 2:
                            return '2nd*';
                        case 3:
                            return '3rd*';
                        case 4:
                            return '4th*';
                        case 5:
                            return '5th*';
                        case 6:
                            return gName === 'Powerball'
                                ? 'Power*'
                                : gName === 'Mega Millions'
                                    ? 'Mega*'
                                    : gName === 'Lotto America'
                                        ? 'Star*'
                                        : '6th*';
                        default:
                            return '1st*';
                    }
                };
                var hasError = (_a = errors[ticketIndex]) === null || _a === void 0 ? void 0 : _a.find(function (e, i) {
                    return (e === null || e === void 0 ? void 0 : e.key) === index + 1;
                });
                var isSpecialInput = hasAddOn && index === ticket.numbers.length - 1;
                var specialInput = '';
                if (isSpecialInput) {
                    specialInput = isNewVersion ? classes.specialNumber : classes.specialNumberBackground;
                }
                var indexLabelStyle = isNewVersion ? classes.indexLabel : classes.indexLabelUpdated;
                var indexLabelErrorStyle = isNewVersion
                    ? classes.inputLabelError
                    : classes.indexLabelError;
                return (react_1.default.createElement(core_1.Box, { display: "flex", flexDirection: "column", key: "".concat(ticketIndex + 1, "-").concat(index + 1) },
                    react_1.default.createElement(core_1.FormControl, { fullWidth: true },
                        react_1.default.createElement(core_1.InputLabel, { shrink: false, className: hasError ? indexLabelErrorStyle : indexLabelStyle, htmlFor: "ticket-input-".concat(ticketIndex + 1, "-").concat(index + 1) },
                            react_1.default.createElement(core_1.Typography, { variant: 'srOnly' }, "Ticket ".concat(ticketIndex + 1, ", ")),
                            getIndex(index + 1, gameName)),
                        react_1.default.createElement(core_1.Input, { id: "ticket-input-".concat(ticketIndex + 1, "-").concat(index + 1), className: (0, classnames_1.default)([
                                classes.numberInput,
                                isNewVersion
                                    ? hasError
                                        ? classes.numberInputErrorUpdated
                                        : classes.numberInputUpdated
                                    : '',
                                hasError ? classes.numberErrorInput : undefined,
                                specialInput
                            ]), value: number >= 0 ? number : '', key: "".concat(ticketIndex + 1, "-").concat(index + 1), onChange: onChange, onBlur: onBlur, onKeyDown: onKey, inputRef: function (el) { return (inputRefs.current[index] = el); }, classes: { input: classes.centerText }, inputProps: {
                                'aria-required': 'true'
                            }, autoComplete: "off" }))));
            }),
            isNewVersion && (react_1.default.createElement(core_1.Box, { sx: {
                    display: 'flex',
                    justifyContent: hasAddOn ? 'space-between' : 'flex-end',
                    width: isLottoAmerica
                        ? mobileViewport
                            ? '100%'
                            : '65%'
                        : mobileViewport
                            ? '100%'
                            : 'auto',
                    marginTop: mobileViewport ? theme.spacing(2.5) : 0,
                    marginRight: mobileViewport ? theme.spacing(4) : 0
                } })))));
};
exports.default = Ticket;
//# sourceMappingURL=AccessibleTicket.js.map